<template>
  <div>
    <div class="staffMesgbox">
      <div class="flexAllcenter marginbottom1">
        <div class="textfont">修改管理员账号</div>
      </div>
      <div class="flexcenter paddingtb1 borderbottom">
        <div class="textfont">手机号：</div>
        <input
          class="staffinput"
          v-model="phoneNum"
          placeholder="请输入修改的手机号"
        />
      </div>
      <div class="flexcenter paddingtb1 borderbottom">
        <div class="textfont">密码：</div>
        <input
          class="staffinput"
          v-model="password"
          placeholder="请输入修改的密码"
        />
      </div>
      <div class="flexcenter paddingtb1 borderbottom">
        <div class="textfont">姓名：</div>
        <input
          class="staffinput"
          v-model="name"
          placeholder="请输入修改的姓名"
        />
      </div>
      <div class="flexbetween paddingtb1">
        <div class="flexcenter">
          <div class="textfont">验证码：</div>
          <input
            class="codeinput"
            v-model="phoneCode"
            placeholder="请输入验证码"
          />
        </div>
        <div
          class="codeBotton"
          @click="!currentTime ? tap('getPhoneCode') : ''"
        >
          {{ currentTime ? currentTime : "获取验证码" }}
        </div>
      </div>
    </div>
    <div
      class="addbotton1"
      @click="!buttonClicked ? tap('changePhoneNum') : ''"
    >
      确定修改
    </div>
    <div class="flexAllcenter">
      <div class="textfont tipcolor1 ">修改成功后，当前账号作废</div>
    </div>
  </div>
</template>

<script>
import httper from "../../../api/http";
var phone_mreg = /^1[2-9][0-9]{9}$/;
export default {
  data() {
    return {
      phoneNum: "", //修改手机号
      password: "", //修改密码
      name: "", //修改姓名
      phoneCode: "", // 验证码,默认为空
      currentCode: "", // 接口获取正确的验证码,默认为空
      currentTime: "", // 验证码倒计时,默认为空
      buttonClicked: false // 防止支付重复点击,默认为false
    };
  },
  created() {},
  mounted() {},
  methods: {
    /**
     * 防重点击
     * @param duration
     * @returns {Promise<any>}
     */
    buttonClickedFun(duration = 0) {
      this.buttonClicked = true;
      return new Promise((resolve, reject) => {
        if (duration && typeof duration === "number") {
          setTimeout(() => {
            this.buttonClicked = false;
          }, duration);
        }
        resolve(true);
      });
    },
    // 点击触发
    tap(type, params = "") {
      let that = this;
      let requestData = {};
      switch (type) {
        // 获取验证码
        case "getPhoneCode":
          that.buttonClickedFun(1500);
          if (!phone_mreg.test(that.phoneNum)) {
            that.$toast({
              message: "请输入正确手机号"
            });
            return;
          }
          requestData.mobile = that.phoneNum;
          that.request("sendCode", requestData);
          break;
        // 绑定手机号码
        case "changePhoneNum":
          that.buttonClickedFun(1500);

          if (!phone_mreg.test(that.phoneNum)) {
            that.buttonClicked = false;
            that.$toast({
              message: "请输入正确手机号！"
            });
            return;
          }
          if (that.password == "") {
            that.$toast({
              message: "密码不能为空！"
            });
            return;
          }
          if (that.name == "") {
            that.$toast({
              message: "姓名不能为空！"
            });
            return;
          }
          if (that.phoneCode == "") {
            that.$toast({
              message: "验证码不能为空！"
            });
            return;
          }
          if (that.phoneCode != that.currentCode) {
            that.buttonClicked = false;
            that.$toast({
              message: "请输入正确的验证码！"
            });
            return;
          }

          requestData.mobile = that.phoneNum;
          requestData.password = that.password;
          requestData.name = that.name;
          that.request("changeSupAdmin", requestData);
          that.buttonClicked = false;
          break;
      }
    },
    // 调用接口
    request(type = "", requestData = {}) {
      let that = this;
      switch (type) {
        //修改超级管理员
        case "changeSupAdmin":
          httper.post(
            "user/change-super-admin",
            requestData,
            function(res) {
              if (res.code === 0) {
                that.$toast({
                  message: "修改成功"
                });
                that.$router.push({
                  path: "/"
                });
              } else {
                that.$toast({
                  message: res.message || "操作失败"
                });
              }
            },
            true
          );
          break;
        // 发送短息验证码
        case "sendCode":
          httper.post("msg/send-code", requestData, res => {
            console.log("code：", res.data);
            if (res.code == 0) {
              that.currentCode = res.data;
              that.$toast({
                message: "验证码已发送"
              });
              // 倒计时
              let time = 91;
              let interval = setInterval(() => {
                time--;
                if (time > 10) {
                  that.currentTime = time + "秒";
                }
                if (time > 0 && time <= 10) {
                  that.currentTime = " " + time + "秒";
                }
                if (time <= 0) {
                  clearInterval(interval);
                  that.currentTime = "";
                }
              }, 1000);
            }
          });
          break;
      }
    }
  }
};
</script>

<style>
.staffMesgbox {
  width: calc(100% - 20px);
  margin: 10px;
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: 8px;
}

input::-webkit-input-placeholder {
  text-align: start;
}

.codeBotton {
  width: 120px;
  height: 31px;
  border: 1px solid #3157a3;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #3157a3;
}

.codeinput {
  width: 130px;
}
</style>



// WEBPACK FOOTER //
// src/pages/mine/adminNum.vue